export const RoleConstant = {
    MOBCHECK_ADMIN: 'MOBCHECK_ADMIN',
    COMPANY_GROUP_ADMIN: 'COMPANY_GROUP_ADMIN',
    COMPANY_ADMIN: 'COMPANY_ADMIN',
    COMPANY_OPERATOR: 'COMPANY_OPERATOR',
    ANONYMOUS: 'ANONYMOUS',
    SERVICE_ADMIN: 'SERVICE_ADMIN',
    SERVICE_WORKSHOP: 'SERVICE_WORKSHOP',
    SERVICE_CLIENT: 'SERVICE_CLIENT'
};

export const BEPI_RESTRICTED_ROLES = [
    RoleConstant.MOBCHECK_ADMIN,
    RoleConstant.SERVICE_ADMIN,
    RoleConstant.SERVICE_WORKSHOP,
    RoleConstant.SERVICE_CLIENT
];